module.exports = __webpack_public_path__ + "media/images/illust/illust-g20s-b0dbb76efd6d976417284e472118b6e3.svg";